import { agentAvatar } from '@/components/admin/cmo/agent-persona';

/**
 * Sage's avatar rendered as a sidebar nav icon — mirrors the admin "Sage Support"
 * item so the user-facing Support entry shares the same face. Accepts the sizing
 * className the sidebar passes (h-5 w-5 …); color classes are no-ops on an image.
 */
export function SageNavIcon({ className }: { className?: string }) {
  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src={agentAvatar('support')}
      alt=""
      className={className}
      style={{ borderRadius: '9999px', objectFit: 'cover' }}
    />
  );
}
